// `??` (not `||`) so an explicit empty VITE_API_URL means "same-origin / relative URLs"
// (used by PR Apps, where the server co-serves the web SPA via SERVE_WEB=true). Only an
// unset (undefined) value falls back to the local dev API.
export const API_BASE = import.meta.env.VITE_API_URL ?? "http://api.navigator.local";
export const ADMIN_URL = import.meta.env.VITE_ADMIN_URL || "https://admin.navigator.local";
